import React, { useState, useEffect, useRef, useCallback } from "react";
import classes from "./ChatScreen.module.css";
import clsx from "clsx";
import { Tabs, Text, TextArea } from "components/common";
import { BiUpArrowAlt } from "react-icons/bi";
import { RiUploadCloud2Line } from "react-icons/ri";
import ResponseMessage from "./Response/ResponseMessage";
import { fetchAIResponse } from "utils/fetchApi";
import {
  creativeMind,
  fitnessCoach,
  friendlyHelper,
  Logo,
  smartAdvisor,
  techGuru,
  temeLogo,
} from "images";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { appendChat, db, deleteChatsByChatId } from "../../db";
import { useLiveQuery } from "dexie-react-hooks";
import { useAppContext } from "ContextProvider/ContextProvider";
import useChatScrollBottom from "hooks/useChatScrollBottom";
import CharacterInfo from "./CharacterInfo/CharacterInfo";
import { TfiWorld } from "react-icons/tfi";
import ResponseHeader from "./Response/ResponseHeader/ResponseHeader";
import Devider from "components/common/Devider/Devider";
import { generateRandomString } from "utils/generateRandomString";
import { PiFan } from "react-icons/pi";
import { toast } from "react-toastify";
import ChatInput from "./ChatInput";
import ResponseImage from "./Response/ResponseImage/ResponseImage";
import axios from "axios";
import { scrollToBottom } from "utils/utils";
import ManageAccountLayout from "Layout/ManageAccountLayout/ManageAccountLayout";
import Cookies from "js-cookie";

const aiCharacters = [
  { img: smartAdvisor, name: "Smart Advisor" },
  { img: friendlyHelper, name: "Friendly Helper" },
  { img: techGuru, name: "Tech Guru" },
  { img: creativeMind, name: "Creative Mind" },
  { img: fitnessCoach, name: "Fitness Coach" },
];

// Debounce helper
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Memoized message components
const MemoizedResponseMessage = React.memo(ResponseMessage);
const MemoizedResponseImage = React.memo(ResponseImage);

const ChatUI = ({
  selectedModel,
  aiCharacters,
  showSelectAiDropdown,
  setShowSelectAiDropdown,
  userData,
}) => {
  const { myTheme } = useAppContext();
  const [loading, setLoading] = useState(false);
  const abortController = useRef(null);
  const [uploadedFile, setUploadedFile] = useState("");
  const [isWebEnabled, setIsWebEnabled] = useState(false);
  const isCancelling = useRef(false);
  const systemMessageIndexRef = useRef(-1);
  const updateBufferRef = useRef("");
  const lastUpdateTimeRef = useRef(Date.now());
  const accumulatedTextRef = useRef("");

  // Create debounced update function at component level
  const debouncedUpdateMessage = useCallback(
    debounce((text, index) => {
      setMessages((prevMessages) => {
        const lastMessage = prevMessages[index];
        if (!lastMessage) return prevMessages;

        const updatedMessages = [...prevMessages];
        updatedMessages[index] = {
          ...lastMessage,
          content: text,
        };
        return updatedMessages;
      });
    }, 100),
    []
  );

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedFile(file);
    }
  };
  const [currentChat, setCurrentChat] = useState();
  let { chatId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const prompt = queryParams.get("prompt");

  const [newChat, setNewChat] = useState("");
  let { aiCharacter } = useParams();
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);

  const [reloadMessagesFromDb, setReloadMessagesFromDb] = useState(false);
  function reloadMessages() {
    setReloadMessagesFromDb(!reloadMessagesFromDb);
  }

  // let dbMessages = useLiveQuery(() => db
  // .chats
  // .where("chatId")
  // .equals(chatId)
  // .toArray());

  async function getChatMessages() {
    if (!chatId) {
      console.log("wrong", "no chat id");
      setMessages([]);
      return;
    }
    let dbMessages = await db.chats.where("chatId").equals(chatId).toArray();
    console.log("dbMessages", dbMessages);
    console.log("wrong", chatId);
    if (!chatId) {
      console.log("wrong", "no chat id. rendering 0");

      setMessages([]);
      return;
    }
    let sortedMsgs = dbMessages
      ?.sort((a, b) => a.timestamp - b.timestamp)
      .filter((s) => s.chatId == chatId);
    setMessages(sortedMsgs);
  }
  useEffect(() => {
    getChatMessages();
  }, [chatId, reloadMessagesFromDb]);

  const [input, setInput] = useState("");
  const targetRef = useRef();
  useChatScrollBottom(reloadMessages);

  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

  const sendMessage = async (withInput) => {
    let inputToAi = withInput || input;
    if (!inputToAi) {
      alert("Please ask before sending.");
      return;
    }
    setLoading(true);

    abortController.current = new AbortController();

    let id = chatId || generateRandomString(25);
    chatId = id;
    const currentPath = window.location.pathname;
    const expectedPath = !aiCharacter
      ? `/chat/${id}`
      : `/chat/${id}/${aiCharacter}`;
    if (currentPath !== expectedPath) {
      navigate(expectedPath);
    }
   

    let user_msg = generateRandomString(12);
    localStorage.setItem(`header-${id}`, input || withInput);

    // Create complete user message object
    let userMsg = {
      type: selectedModel?.model_type.toLowerCase(),
      images: null,
      id: user_msg,
      chatId: id,
      content: inputToAi,
      role: "user",
      model: selectedModel.name,
      firstResponseTime: 0,
      loading: true,
      timestamp: new Date().getTime(),
      heading: inputToAi,
      character: aiCharacter,
    };

    await db.chats.add(userMsg);

    // Update messages with user message
    setMessages((prevMessages) => [...prevMessages, { ...userMsg }]);
    // Store chat metadata in localStorage
    const metadata = {
      chatId: id,
      heading: inputToAi,
      character: aiCharacter,
      lastUpdated: new Date().getTime(),
    };
    // localStorage.setItem(`chat-metadata-${id}`, JSON.stringify(metadata));
    db.chatMetadata.add(metadata);

    setInput("");

    
    setTimeout(scrollToBottom, 0);
    let api = process.env.REACT_APP_API;
    let startTime = Date.now();

    try {
      if (selectedModel?.model_type?.toLowerCase() == "chat") {
        const response = await fetchAIResponse(
          `${api}/chat/completions`,
          inputToAi,
          selectedModel.id,
          messages
            .filter((a) => a.type.toLowerCase() == "chat")
            .map((a) => {
              return {
                role: a.role,
                content: a.content,
              };
            }),
          aiCharacter,
          abortController.current
        );

        if (!response.ok) {
          if (response.status === 429) {
            const errorMessage = {
              content:
                "⚡️ You've reached the rate limit. Upgrade to PRO for unlimited access!",
              role: "assistant",
              type: "error",
              error: true,
              timestamp: new Date().getTime(),
            };

            setMessages((prevMessages) => {
              const updatedMessages = [...prevMessages];
              const lastIndex = updatedMessages.length - 1;
              if (lastIndex >= 0 && updatedMessages[lastIndex].loading) {
                updatedMessages[lastIndex] = errorMessage;
              } else {
                updatedMessages.push(errorMessage);
              }
              return updatedMessages;
            });

            db.chats.add({
              ...errorMessage,
              chatId: id,
              model: selectedModel.name,
              character: aiCharacter,
            });

            setLoading(false);
            reloadMessages();
            return;
          }
          const errorData = await response.text();
          throw new Error(errorData || "Failed to get response from AI");
        }

        if (!response.body) {
          throw new Error("No response received from AI");
        }

        streamResponse(response, startTime, id);
      }
      if (selectedModel?.model_type?.toLowerCase() == "image") {
        console.log("debug", "into image");

        let startTime = Date.now();

        let url = process.env.REACT_APP_API + "/image/generate";
        let { data } = await axios.post(
          url,
          {
            model: selectedModel.id,
            prompt: inputToAi,
            negative_prompt: "",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Cookies.get("token")}`,
              session: "x",
            },
          }
        );

        let first_res = Date.now();
        const durationSeconds = (first_res - startTime) / 1000;

        let systemMessageIndex = -1;
        setMessages((prevMessages) => {
          systemMessageIndex = prevMessages.length;
          return [
            ...prevMessages,
            { content: "", role: "assistant", loading: true },
          ];
        });

        db.chats.add({
          type: selectedModel?.model_type.toLowerCase(),
          images: data?.images || [],
          chatId: id,
          content: "",
          role: "assistant",
          model: selectedModel.name,
          firstResponseTime: durationSeconds,
          loading: true,
          timestamp: new Date().getTime(),
          heading: input || "accumulatedText",
          character: aiCharacter,
        });

        setMessages((prevMessages) => {
          const updatedMessages = [...prevMessages];
          if (systemMessageIndex !== -1) {
            updatedMessages[systemMessageIndex] = {
              type: selectedModel?.model_type.toLowerCase(),
              images: data?.images || [],
              chatId: id,
              content: "",
              role: "assistant",
              model: selectedModel.name,
              firstResponseTime: durationSeconds,
              loading: true,
              timestamp: new Date().getTime(),
            };
          }
          return updatedMessages;
        });

        setLoading(false);
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Request cancelled");
        const timestamp = new Date().getTime();
        const cancelMessage = {
          content: "User cancelled request",
          role: "assistant",
          type: "error",
          error: true,
          timestamp: timestamp,
        };

        // setMessages((prevMessages) => {
        //   const updatedMessages = [...prevMessages];
        //   const lastIndex = updatedMessages.length - 1;
        //   if (lastIndex >= 0 && updatedMessages[lastIndex].loading) {
        //     updatedMessages[lastIndex] = cancelMessage;
        //   } else {
        //     updatedMessages.push(cancelMessage);
        //   }
        //   return updatedMessages;
        // });

        // await db.chats.add({
        //   ...cancelMessage,
        //   chatId: id,
        //   model: selectedModel.name,
        //   character: aiCharacter,
        // });

        // // Update chat metadata with new timestamp
        // await db.chatMetadata.update(id, {
        //   lastUpdated: timestamp,
        // });
      } else {
        console.error("Error fetching AI response:", error);
        const timestamp = new Date().getTime();
        const errorMessage = {
          content:
            error.message ||
            "An error occurred while fetching the response. Please try again.",
          role: "assistant",
          type: "error",
          error: true,
          timestamp: timestamp,
        };

        setMessages((prevMessages) => {
          const updatedMessages = [...prevMessages];
          const lastIndex = updatedMessages.length - 1;
          if (lastIndex >= 0 && updatedMessages[lastIndex].loading) {
            updatedMessages[lastIndex] = errorMessage;
          } else {
            updatedMessages.push(errorMessage);
          }
          return updatedMessages;
        });

        await db.chats.add({
          ...errorMessage,
          chatId: id,
          model: selectedModel.name,
          character: aiCharacter,
        });

        // Update chat metadata with new timestamp
        await db.chatMetadata.update(id, {
          lastUpdated: timestamp,
        });
      }
      setLoading(false);

      reloadMessages();
    }
  };

  const streamResponse = async (response, startTime, id) => {
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    accumulatedTextRef.current = "";
    let messageId = generateRandomString(22);
    let firstResponseTime = 0;
    let lastUpdateTime = Date.now();
    const UPDATE_INTERVAL = 1; // Update UI every 100ms

    try {
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        console.log(chunk);
        const lines = chunk.split("\n");
        for (const line of lines) {
          if (firstResponseTime === 0) {
            firstResponseTime = (Date.now() - startTime) / 1000;

            // Create initial AI message
            const initialMessage = {
              id: messageId,
              type: selectedModel?.model_type.toLowerCase(),
              images: null,
              chatId: id,
              content: "",
              role: "assistant",
              model: selectedModel.name,
              firstResponseTime: firstResponseTime,
              loading: true,
              timestamp: new Date().getTime(),
            };

            // Add initial AI message to state
            setMessages((prevMessages) => {
              systemMessageIndexRef.current = prevMessages.length;
              return [...prevMessages, initialMessage];
            });
          }

          if (line.startsWith("data: ")) {
            const data = line.replace("data: ", "").trim();
            if (data === "[DONE]") {
              setLoading(false);
              const timestamp = new Date().getTime();
              // Save to DB first before final UI update
              db.chats.add({
                id: messageId,
                type: selectedModel?.model_type.toLowerCase(),
                images: null,
                chatId: id,
                content: accumulatedTextRef.current,
                role: "assistant",
                model: selectedModel.name,
                firstResponseTime: firstResponseTime,
                loading: false,
                timestamp: timestamp,
              });

              // Update chat metadata with new timestamp
              db.chatMetadata.update(id, {
                lastUpdated: timestamp,
              });

              // Final single update to UI
              setMessages((prevMessages) => {
                const updatedMessages = [...prevMessages];
                if (systemMessageIndexRef.current >= 0) {
                  updatedMessages[systemMessageIndexRef.current] = {
                    ...updatedMessages[systemMessageIndexRef.current],
                    loading: false,
                    firstResponseTime: firstResponseTime,
                    content: accumulatedTextRef.current,
                  };
                }
                return updatedMessages;
              });

              break;
            }
            // done

            try {
              const json = JSON.parse(data);
              const content = json.choices?.[0]?.delta?.content || "";
              if (content) {
                accumulatedTextRef.current += content;

                // Throttle UI updates to avoid excessive re-renders
                const now = Date.now();
                if (now - lastUpdateTime >= UPDATE_INTERVAL) {
                  setMessages((prevMessages) => {
                    const updatedMessages = [...prevMessages];
                    if (systemMessageIndexRef.current >= 0) {
                      updatedMessages[systemMessageIndexRef.current] = {
                        ...updatedMessages[systemMessageIndexRef.current],
                        content: accumulatedTextRef.current,
                      };
                    }
                    return updatedMessages;
                  });
                  lastUpdateTime = now;
                }
              }
            } catch (error) {
              console.error("Error parsing JSON:", error);
            }
          }
        }
      }
    } catch (error) {
      console.error("Error in streamResponse:", error);
      setLoading(false);
    }
  };

  let sent = 0;
  async function sendWithPrompt() {
    if (prompt && sent == 0) {
      sent = 1;
      console.log("prompt", prompt);
      sendMessage(prompt);
    }
  }
  useEffect(() => {
    sendWithPrompt();
  }, []);
  const matchedCharacter = aiCharacters.find(
    (character) => character.id === aiCharacter
  );
  const stopStreaming = async () => {
    if (abortController.current && !isCancelling.current) {
      isCancelling.current = true;
      abortController.current.abort();
      abortController.current = null;

      // Add cancel message to messages
      const cancelMessage = {
        content: "User cancelled request",
        role: "assistant",
        type: "error",
        error: true,
        timestamp: new Date().getTime(),
      };

      setMessages((prevMessages) => {
        const updatedMessages = [...prevMessages];
        const lastIndex = updatedMessages.length - 1;
        if (lastIndex >= 0 && updatedMessages[lastIndex].loading) {
          updatedMessages[lastIndex] = cancelMessage;
        }
        return updatedMessages;
      });

      // Also add to database for persistence
      await db.chats.add({
        ...cancelMessage,
        chatId: chatId,
        model: selectedModel.name,
        character: aiCharacter,
      });

      setLoading(false);

      // Reset the cancelling flag after a short delay
      setTimeout(() => {
        isCancelling.current = false;
      }, 500);

      reloadMessages();
    }
  };

  return (
    <>
      <div className={clsx(classes.wrapper)}>
        <div className={clsx(classes.chatBox, "chatBox")}>
          {matchedCharacter && <CharacterInfo {...matchedCharacter} />}
          {!matchedCharacter && (
            <CharacterInfo
              logo={           <img src={temeLogo} alt="#"  />            }
              name={`Hi I am ${selectedModel.name}`}
              info="How can I help you today?"
            />
          )}

          {messages?.length > 0 &&
            messages.map((msg, index) => {
              const lastMessage = messages.length - 1 === index;

              return (
                <div
                  className={lastMessage && classes.hScreen}
                  key={msg.id || index}
                >
                  {msg?.role === "user" && (
                    <>
                      <Text className={classes.userMessage}>
                        {msg?.content
                          ?.split("\n")
                          .filter((line) => line.trim() !== "")
                          .map((line, idx) => (
                            <span key={idx}>
                              {line}
                              <br />
                            </span>
                          ))}
                      </Text>
                      <ResponseHeader
                        aiCharacter={aiCharacter}
                        aiCharacters={aiCharacters}
                        msg={msg}
                        firstResponseTime={
                          messages[index + 1]?.role === "assistant" &&
                          messages[index + 1]?.firstResponseTime
                        }
                        isLoading={
                          loading &&
                          lastMessage &&
                          index + 1 !== messages.length - 1
                        }
                      />
                    </>
                  )}

                  {msg?.role === "assistant" && (
                    <>
                      {(msg?.type?.toLowerCase() === "chat" ||
                        msg?.type === "error") && (
                        <MemoizedResponseMessage
                          loading={loading}
                          msg={msg}
                          aiCharacters={aiCharacters}
                          aiCharacter={aiCharacter}
                          userData={userData}
                        />
                      )}
                      {msg?.type?.toLowerCase() === "image" && (
                        <MemoizedResponseImage msg={msg} />
                      )}
                    </>
                  )}
                </div>
              );
            })}
        </div>

        <ChatInput
          generating={loading}
          setIsWebEnabled={setIsWebEnabled}
          isWebEnabled={isWebEnabled}
          selectedModel={selectedModel}
          onCancel={stopStreaming}
          chatId={chatId}
          input={input}
          setInput={setInput}
          sendMessage={sendMessage}
          aiCharacter={aiCharacter}
          loading={loading}
          showSelectAiDropdown={showSelectAiDropdown}
          setShowSelectAiDropdown={setShowSelectAiDropdown}
          setUploadedFile={setUploadedFile}
          uploadedFile={uploadedFile}
        />
      </div>

      <ManageAccountLayout
        isActive={showSubscriptionModal}
        onClose={() => setShowSubscriptionModal(false)}
        isLoggedIn={true}
        userData={userData}
      />
    </>
  );
};

export default React.memo(ChatUI);
